import { Dispatch, ReactNode, SetStateAction } from 'react';
import { LoadingSpinner } from '../loadingSpinner/loadingSpinner';
import { ColumnSort } from '../columnSort/columnSort';

type SortColumn = {
  sortAscending: number;
  sortDescending: number;
};

type HeaderProps = {
  name: string;
  sort?: SortColumn;
};

type Props = {
  mainHeader: HeaderProps;
  attributeHeaders: HeaderProps[];
  children: ReactNode;
  loading: boolean;
  elements: number;
  sortBy?: number;
  setSortBy?: Dispatch<SetStateAction<number>>;
};

export function Table({
  mainHeader,
  attributeHeaders,
  children,
  loading,
  elements,
  sortBy,
  setSortBy,
}: Readonly<Props>) {
  return (
    <div className="h-full relative overflow-x-auto rounded-lg">
      {loading && (
        <div className="absolute inset-0 flex flex-col justify-center items-center bg-opacity-30 bg-gray-200">
          <LoadingSpinner classToAdd="w-8 h-8" />
          <p className="mt-2">Loading</p>
        </div>
      )}
      {!loading && !elements && (
        <div className="absolute inset-0 flex flex-col justify-center items-center bg-opacity-30 bg-gray-200">
          <p className="mt-2">There are no elements to show.</p>
        </div>
      )}
      {!loading && elements ? (
        <table className="w-full text-sm text-left rtl:text-right text-gray-500 absolute">
          <thead className="text-xs text-gray-700 bg-gray-50 uppercase">
            <tr>
              {mainHeader.sort && sortBy !== undefined && setSortBy ? (
                <ColumnSort
                  header={{ ...mainHeader, sort: mainHeader.sort }}
                  sortBy={sortBy}
                  setSortBy={setSortBy}
                />
              ) : (
                <th scope="col" className="text-center px-6 py-3">
                  {mainHeader.name}
                </th>
              )}

              {attributeHeaders.map(element =>
                element.sort && sortBy !== undefined && setSortBy ? (
                  <ColumnSort
                    header={{ ...element, sort: element.sort }}
                    sortBy={sortBy}
                    setSortBy={setSortBy}
                    key={element.name}
                  />
                ) : (
                  <th
                    scope="col"
                    className="text-center px-6 py-3"
                    key={element.name}
                  >
                    {element.name}
                  </th>
                ),
              )}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      ) : null}
    </div>
  );
}
